import FirestoreModel from './FirestoreModel'
import { dateformat, gte, equal, number, required, string } from 'vue-mc/validation'

/**
 * @class
 * @typedef {FirestoreModel} TripStep
 */
export default class TripStep extends FirestoreModel {
  modelName = 'Step'
  collection = 'trip-steps'
  autoFields = true

  defaults () {
    return {
      id: null,
      tripId: null,
      name: '',
      startDate: null,
      endDate: '',
      type: null,
      cost: 0,
      location: null,
      lat: null,
      lng: null,
      image: null,
      url: null
    }
  }

  mutations () {
    return {}
  }

  validation () {
    return {
      tripId: required.and(string),
      name: string.or(equal(null)),
      startDate: equal(null).or(equal('')).or(dateformat('yyyy-MM-dd')),
      endDate: equal(null).or(equal('')).or(dateformat('yyyy-MM-dd')),
      type: string.or(equal(null)),
      cost: gte(0),
      location: string.or(equal(null)),
      lat: number.or(equal(null)),
      lng: number.or(equal(null)),
      country: string.or(equal(null)),
      image: string.or(equal(null))
    }
  }

  options () {
    return {
      validateOnChange: true
    }
  }
}
